import { useTranslation } from '@frontend/i18n';
import { IconName } from '@frontend/icons';
import { Accordion, Text, useTooltip } from '@frontend/design-system';
import { FilterCount } from '../popover-filter-panel-content/filter-count';

export const CustomAccordionHeader = ({
  title,
  icon,
  filterCount,
  disabled,
}: {
  title: string;
  icon?: IconName;
  filterCount?: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('scheduleCalendarFilters');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'bottom' });

  return (
    <>
      <Accordion.Header
        disabled={disabled}
        {...triggerProps}
        css={{
          '.header-container': {
            padding: 'var(--fabric-space-gap-sm) var(--fabric-space-gap-md)',
            justifyContent: 'space-between',
            alignItems: 'center',
          },
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {icon ? (
          <Accordion.Header.Icon title={title} icon={icon} css={{ fontWeight: 'var(--fabric-font-weight-bold)' }} />
        ) : (
          <Text weight='bold'>{title}</Text>
        )}
        <FilterCount count={filterCount} size='small' />
      </Accordion.Header>
      {disabled && (
        <Tooltip {...tooltipProps}>
          {title} {t('coming soon')}
        </Tooltip>
      )}
    </>
  );
};
